import { Outlet, createRootRoute } from "@tanstack/react-router";
import { useState } from "react";
import Login from "src/components/login";

const SESSION_KEY = "mock_session_expiry";
const SESSION_DURATION_MS = 2 * 60 * 60 * 1000; // 2 hours

function isSessionValid(): boolean {
    const expiry = sessionStorage.getItem(SESSION_KEY);
    if (!expiry) return false;
    return Date.now() < parseInt(expiry, 10);
}

function RootComponent() {
    const [authed, setAuthed] = useState(isSessionValid);

    function handleLogin() {
        sessionStorage.setItem(SESSION_KEY, String(Date.now() + SESSION_DURATION_MS));
        setAuthed(true);
    }

    return (
        <>
            <Outlet />
            {!authed && <Login onLogin={handleLogin} />}
        </>
    );
}

export const Route = createRootRoute({
    component: RootComponent,
});
